import { Col } from 'antd';
import styled from 'styled-components';

export const SearchCol = styled(Col)`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
`;

export const TableTop = styled(Col)`
  display: flex;
  align-items: end;
  justify-content: end;
  gap: 20px;
  margin-bottom: 20px;
  flex-direction: ${props => (props.isMob ? 'column' : 'row')};
`;
